export default __webpack_public_path__ + "static/VictorMono-Bold-1dc828d583dbf9911682435329383a1e.woff2";